import { SetStateAction, useState } from "react";
import { IVehicle } from "../../models/Vehicle";
import GenericCell from "../shared/Cells/GenericCell";
import Modal from "../../layouts/Modal";
import CODStatus from "../leads/LeadInformation/CODStatus";


export default function VehicleCollectedCODStatus({ leadId, vehicle }: { leadId: string, vehicle: IVehicle | null }) {
  const [open, setOpen] = useState(false);

  if (!vehicle) return null;

  return (
    <>
      <Modal open={open} width={"max-w-2xl"} setOpen={setOpen} >
        <CODStatus leadId={leadId} />
      </Modal>

      <div
        onClick={(e) => { e.stopPropagation(); setOpen(true) }}
        className="py-6 hover:bg-gray-200 hover:shadow hover:scale-110 cursor-pointer"
      >
        {vehicle?.codRequired ? (
          <GenericCell text={vehicle?.codConfirmedOn ? "COD Confirmed" : "No COD"} colour={vehicle?.codConfirmedOn ? "green" : "yellow"} title="COD Status" />
        ) : (
          <GenericCell text={"COD Not Required"} colour={"purple"} title="COD Not Required" />
        )}
      </div>
    </>
  )
}